module.exports = __webpack_public_path__ + "ccb23d8da77c7eb87e41dd94164224b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/lisa_blatter.jpg
// module id = 112
// module chunks = 0